import React, { useCallback } from 'react';
import { View } from 'react-native';
import { useSupabaseAuth } from '../../../src/shared/contexts/SupabaseAuthContext';
import { useWorldCupWelcomeMenuStore } from '../../../src/worldcup/stores/worldCupWelcomeMenuStore';
import { writeWorldCupWelcomeCompleted } from '../../../src/worldcup/helpers/worldcupWelcomeStorage.helper';
import { enforceImmersiveMode } from '../../../src/shared/helpers/immersiveMode.helper';
import { WorldCupWelcomeScreen } from '../WorldCupWelcomeScreen/WorldCupWelcomeScreen';
import { worldCupRulesFromMenuOverlayStyles as styles } from './WorldCupRulesFromMenuOverlay.styles';

/**
 * Renders the World Cup welcome/rules flow above the current route (no tab navigation).
 */
export const WorldCupRulesFromMenuOverlay: React.FC = () => {
  const rulesOverlayOpen = useWorldCupWelcomeMenuStore((s) => s.rulesOverlayOpen);
  const closeWorldCupRulesOverlay = useWorldCupWelcomeMenuStore((s) => s.closeWorldCupRulesOverlay);
  const { user } = useSupabaseAuth();
  const userId = user?.id ?? null;

  const handleEnter = useCallback(() => {
    void (async () => {
      try {
        await writeWorldCupWelcomeCompleted(userId);
      } finally {
        await enforceImmersiveMode();
        closeWorldCupRulesOverlay();
      }
    })();
  }, [userId, closeWorldCupRulesOverlay]);

  if (!rulesOverlayOpen) {
    return null;
  }

  return (
    <View style={styles.host} pointerEvents="auto" testID="worldcup-rules-from-menu-overlay">
      <WorldCupWelcomeScreen onEnter={handleEnter} testID="worldcup-welcome-from-menu" />
    </View>
  );
};
